import { BodyText, Button, Caption, IdentityVerifiedIllu, Modal } from '@farol-ds/react'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { formatDate } from '@jusbrasil-web/shared-utils-format'
import { useEffect, useRef, useState } from 'react'

import { useGA4Events } from '../../../hooks'
import { useModalContext } from '../../cpf-validation/context'
import styles from './complete-signup-modal.module.scss'
import { NUDGE_CLICK_PROPS, NUDGE_RENDER_PROPS } from './ga4-events'

const AUTO_DISMISS_SECONDS = 3

export interface SuccessStepProps {
  onClose: () => void
}

export function SuccessStep({ onClose }: SuccessStepProps) {
  const { viewer, sharedData, eventData } = useModalContext()
  const pid = viewer?.pid.toString()
  const ga4 = useGA4Events()
  const [secondsLeft, setSecondsLeft] = useState(AUTO_DISMISS_SECONDS)
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose
  const timers = useRef<{
    close?: ReturnType<typeof setTimeout>
    tick?: ReturnType<typeof setInterval>
  }>({})

  function stopCountdown() {
    clearTimeout(timers.current.close)
    clearInterval(timers.current.tick)
  }

  useEffect(() => {
    ga4.sendComponentRender(NUDGE_RENDER_PROPS.SUCCESS)
    sendMetrics('UserAccount.IdValidationSuccessViewed', pid, {
      ...eventData,
      metadata: {
        cpf: sharedData.cpf,
        birthDate: formatDate(sharedData.birthDate?.getTime() || ''),
        ...eventData?.metadata,
      },
    })
    timers.current.close = setTimeout(() => onCloseRef.current(), AUTO_DISMISS_SECONDS * 1000)
    // Clamp at 1 so the visible countdown never flashes "0s" before the modal closes.
    timers.current.tick = setInterval(() => setSecondsLeft((s) => (s > 1 ? s - 1 : s)), 1000)
    return stopCountdown
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onComplete() {
    stopCountdown()
    ga4.sendClick(NUDGE_CLICK_PROPS.SUCCESS_COMPLETE)
    onClose()
  }

  return (
    <>
      <Modal.Body className={styles.centered} data-testid="complete-signup-success-step">
        <IdentityVerifiedIllu />
        <Modal.HeaderTitle>Cadastro atualizado!</Modal.HeaderTitle>
        <BodyText size="md">Agora você pode continuar navegando.</BodyText>
      </Modal.Body>
      <Modal.Footer className={styles.successFooter}>
        <Button kind="primary" onClick={onComplete}>
          Concluir
        </Button>
        <Caption className={styles.redirectCaption}>
          Você será redirecionado em {secondsLeft}s...
        </Caption>
      </Modal.Footer>
    </>
  )
}
